module.exports = __webpack_public_path__ + "img/home-banner4.8a2ee28c.jpg";